var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("HeadInfoSimple", { attrs: { title: "电影" } }),
      _vm._v(" "),
      _c("RelativeSimple"),
      _vm._v(" "),
      _c("Like"),
      _vm._v(" "),
      _c("Gotop"),
      _vm._v(" "),
      _c("Rec"),
      _vm._v(" "),
      _c("Ob"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }